import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Modal,
  Row,
  Image,
  ListGroup,
  ProgressBar,
  Form,
  ListGroupItem,
} from "react-bootstrap";

function PriorityTwoModal({
  type,
  setType,
  product,
  addToCartHandler,
  setSpecification,
  Specification,
}) {
  const [show, setShow] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(true);
  useEffect(() => {
    setSpecification({
      ...Specification,
      onlyFrame: true,
    });
    const handleResize = () => {
      if (window.innerWidth < 768) {
        // Adjust the breakpoint as per your needs
        setIsFullscreen(false);
      } else {
        setIsFullscreen(true);
      }
    };

    handleResize(); // Initial check

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setType("2");
    setSpecification({
      ...Specification,
      // frame: "",
      prescriptionType: " ",
      qty: 1,
      ManualValues: {
        od_sph: 0,
        od_cyl: 0,
        od_axis: 0,
        os_sph: 0,
        os_cyl: 0,
        os_axis: 0,
        Add_Power: 0,
        pd_type: " ",
        pd_value: 0,
        PrescriptionImage: " ",
      },
    });
    setShow(false);
  };
  return (
    <>
      <Row className='text-center'>
        <Button
          type='button'
          onClick={handleShow}
          disabled={product.countInStock === 0}
          className=' Psbutton shadow btn-light m-2'
        >
          Buy Accessory
        </Button>
      </Row>

      <Modal
        //  when the modal body ka cheeze badh jaye toh scrollable karke ek feature daal sakte hai
        animation
        backdrop='static'
        // size='xl'
        dialogClassName={isFullscreen ? "" : "modal-xl"}
        fullscreen={isFullscreen}
        show={show}
        onHide={handleClose}
      >
        <Row style={{ height: "100%" }}>
          <Col style={{ margin: "auto" }} className='text-center' md={4}>
            <Image src={product.image} alt={product.name} fluid />
            <h3>{product.name}</h3>
          </Col>

          {(() => {
            switch (type) {
              case "2":
                return (
                  <Col className='shadow' md={8}>
                    <ProgressBar
                      className=' Fpro shadow'
                      variant='info'
                      animated
                      now={100}
                    />
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Title className='text-center'>
                      Check and Purchase
                    </Modal.Title>
                    <Modal.Body>
                      <ListGroup variant='flush'>
                        <ListGroup.Item>
                          <Row>
                            <Col>Status:</Col>
                            <Col>
                              {product.countInStock > 0
                                ? "In Stock"
                                : "Out Of Stock"}
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        {product.countInStock > 0 && (
                          <ListGroup.Item>
                            <Row>
                              <Col>Qty</Col>
                              <Col>
                                <Form.Control
                                  size='sm'
                                  as='select'
                                  value={Specification.qty}
                                  onChange={(e) =>
                                    setSpecification({
                                      ...Specification,
                                      qty: e.target.value,
                                    })
                                  }
                                >
                                  {[...Array(product.countInStock).keys()].map(
                                    (x) => (
                                      <option key={x + 1} value={x + 1}>
                                        {x + 1}
                                      </option>
                                    )
                                  )}
                                </Form.Control>
                              </Col>
                            </Row>
                          </ListGroup.Item>
                        )}
                        <ListGroupItem>
                          <Row>
                            <Col> Accessory Price:</Col>

                            <Col>${product.price}</Col>
                          </Row>
                        </ListGroupItem>

                        <ListGroup.Item>
                          <Button
                            onClick={addToCartHandler}
                            className='Psbutton btn-light rounded shadow'
                            type='button'
                            disabled={product.countInStock === 0}
                          >
                            Add To Cart
                          </Button>
                        </ListGroup.Item>
                      </ListGroup>
                    </Modal.Body>
                  </Col>
                );

              default:
                return (
                  <Col>
                    Sorry some Error is there, The technical team is looking
                    into it.
                  </Col>
                );
            }
          })()}
        </Row>
      </Modal>
    </>
  );
}

export default PriorityTwoModal;
